import {createBrowserHistory, createMemoryHistory, type History} from 'history';
import Config from 'hooks/config';

/**
 * The history object used by the router depending on whether the application is running in the browser or in a test environment.
 */
const history: History = Config.isTest
    ? createMemoryHistory()
    : createBrowserHistory({
          basename: Config.basename,
      });

export default history;
